import type {FormData, Address} from "../types";
import {emptyAddress} from "../ShipmentEntryInputGroup";

export const validateAllFields = (formData: FormData) => {
  /* eslint-disable camelcase */
  const {
    transportation_mode,
    origin_port,
    destination_port,
    origin_address,
    destination_address,
    weight,
    teus,
  } = formData;

  const errors = {
    transportationMode: validateTransportationMode(transportation_mode),
    originPort: origin_port != null ? validatePort(origin_port, "origin") : "",
    destinationPort:
      destination_port != null
        ? validatePort(destination_port, "destination")
        : "",
    originAddress:
      origin_address != undefined
        ? validateAddress(origin_address, "origin")
        : "",
    destinationAddress:
      destination_address != undefined
        ? validateAddress(destination_address, "destination")
        : "",
    weight: validateWeightorTeus(weight ? weight.value : null, teus ?? ""),
    teus: validateWeightorTeus(weight ? weight.value : null, teus ?? ""),
  };
  /* eslint-enable camelcase */

  // Check if there are any validation errors
  const hasErrors = Object.values(errors).some(error => error !== "");
  return {errors, isValid: !hasErrors};
};

const validateTransportationMode = (transporationMode: string): string => {
  if (!transporationMode) {
    return "Please select a transportation mode.";
  }
  return "";
};

const validatePort = (port: string, type: string): string => {
  if (!port.length) {
    return `Please select an ${type} port.`;
  }
  return "";
};

const validateAddress = (InputAddress: Address, type: string): string => {
  // country code is required
  if (InputAddress === emptyAddress || !InputAddress.country_code) {
    return `Please enter a valid ${type} address.`;
  }
  return "";
};

const validateWeightorTeus = (weight: number | null, teus: string): string => {
  if (weight !== null && weight <= 0) {
    return "Please enter a valid weight or TEU value.";
  }

  if (teus !== "" && parseFloat(teus) <= 0) {
    return "Please enter a valid weight or a TEU value.";
  }

  if (teus === "NaN" || Number.isNaN(weight)) {
    return "Please enter a valid weight or a TEU value.";
  }

  return "";
};
